import { Component } from 'react';
import { Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { actions, Form } from 'forms/rrf';
import { invalidateScans } from '../../../actions/outlet';
import Select from '../../common/form/dropdown';
import RequiredDatePicker from '../../common/form/elements/required-datepicker';
import ArrowButton from '../../common/button-arrow';

class InvalidateScansForm extends Component {
  handleStaffMemberChange = (event) => {
    // Guard against a null event (a cleared select) so we never read null.value — the select is
    // non-clearable, but keep this defensive so re-enabling a clear (x) can't crash the page.
    this.props.dispatch(actions.change('deep.admin_outlet_view.invalidate_scans.staff_member', event ? event.value : ''));
  };

  handleSubmit = (payLoad) => {
    const { id, dispatch } = this.props;
    dispatch(actions.submitFields('deep.admin_outlet_view.invalidate_scans', invalidateScans(id, payLoad, dispatch)));
  };

  render() {
    const {
      staffMembers, staffMember, formValid, dateFrom, dateTo
    } = this.props;

    return (
      <div className="fluid">
        <Form model="deep.admin_outlet_view.invalidate_scans" onSubmit={this.handleSubmit}>
          <Row>
            <Col md={3}>
              Staff member
            </Col>
            <Col md={9}>
              <Select
                data={[
                  { value: '', label: 'All' },
                  ...staffMembers.map(item => ({
                    value: String(item.id),
                    label: item.name
                  }))
                ]}
                model="deep.admin_outlet_view.invalidate_scans.staff_member"
                onChange={this.handleStaffMemberChange}
                value={staffMember || ''}
              />
            </Col>
          </Row>
          <br/>
          <Row>
            <Col md={6}>
              <RequiredDatePicker
                controlId="displayFromDate"
                label="Display from date"
                model="deep.admin_outlet_view.invalidate_scans.invalidate_from_date"
                placeholder="Select a date..."
                timeFormat="HH:mm"
                value={dateFrom}
              />
            </Col>
            <Col md={6}>
              <RequiredDatePicker
                controlId="displayToDate"
                label="Display to date"
                model="deep.admin_outlet_view.invalidate_scans.invalidate_to_date"
                placeholder="Select a date..."
                timeFormat="HH:mm"
                value={dateTo}
              />
            </Col>
          </Row>
          <Row className="mg-top-20">
            <Col className="text-right" md={12}>
              <ArrowButton arrow={false} disabled={!formValid}>
                Invalidate
              </ArrowButton>
            </Col>
          </Row>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  formValid: state.deep.forms.admin_outlet_view.invalidate_scans.$form.valid,
  staffMember: state.deep.admin_outlet_view.invalidate_scans.staff_member,
  dateFrom: state.deep.admin_outlet_view.invalidate_scans.invalidate_from_date,
  dateTo: state.deep.admin_outlet_view.invalidate_scans.invalidate_to_date
});

export default connect(mapStateToProps)(InvalidateScansForm);
